import { ScrollView } from "../ScrollView.js";
import { IScrollViewScale } from "./IScrollViewScale.js";

export class ScrollViewScaleNone implements IScrollViewScale {
    public getScale(view: ScrollView): number {
        return view.scale;
    }
}